import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = false;

// This reducer is used to avoid "flickering" effect when FIRST loading a conversation
// (ie. Showing the latest message, then the others loaded from the DB)
export default createReducer(initialState, {
  [actionTypes.FETCH_MESSAGES_SUCCESS]: () => true,
  [actionTypes.POST_CONVERSATION_SUCCESS]: () => true,
  [LOCATION_CHANGE]: () => false, // FIXME: Bug if you select the same id again as messages aren't fetched again
});
